export interface InsuranceCopy {
  cap: {
    reached: string;
    uploadWithout: string;
  };
  confirm: {
    failedState: {
      notice: string;
    };
    fieldLabels: {
      sub_category_id: string;
      expiry_date: string;
      insured_name: string;
      insurer_name: string;
      policy_number: string;
      value: string;
    };
    subCategoryMismatch: {
      changePrompt: string;
      suggest: string;
    };
    submitButton: string;
    submittingButton: string;
    subtitle: string;
    title: string;
  };
  feedback: {
    addComment: string;
    alreadySubmitted: string;
    commentPlaceholder: string;
    prompt: string;
    submit: string;
    submitting: string;
    successMessage: string;
    thumbsDown: string;
    thumbsUp: string;
  };
  gate: {
    subCategoryFirst: string;
    subCategoryLabel: string;
    uploadInstructions: string;
  };
  pageCountWarning: {
    body: string;
    checkboxLabel: string;
    confirmButton: string;
    title: string;
  };
  pending: {
    body: string;
    replaceFile: string;
    replaceFileLoading: string;
    title: string;
  };
  states: {
    cap_reached: string;
    cap_reached_body: string;
    confirm_page_truncate: string;
    pending_verification: string;
    submitting: string;
  };
  upload: {
    error: string;
    success: string;
  };
}

export const en: InsuranceCopy = {
  cap: {
    reached:
      "Verification limit reached this month ({used}/{limit}). Resets {resetsAt}. You can still upload — verification will be unavailable until then.",
    uploadWithout: "Upload without verification",
  },
  confirm: {
    title: "Confirm Insurance Details",
    subtitle:
      "Please review the details extracted from your document. If any field is incorrect, update the value and provide a reason.",
    submitButton: "Confirm Details",
    submittingButton: "Saving…",
    fieldLabels: {
      expiry_date: "Expiry Date",
      value: "Coverage Value",
      insurer_name: "Insurer Name",
      insured_name: "Insured Name",
      policy_number: "Policy Number",
      sub_category_id: "Insurance Type",
    },
    subCategoryMismatch: {
      suggest:
        'The document suggests the insurance type is "{inferred}" but you selected "{selected}". Would you like to change it?',
      changePrompt: "Change?",
    },
    failedState: {
      notice:
        "We were unable to extract details from your document. Please enter the insurance details manually.",
    },
  },
  gate: {
    subCategoryFirst:
      "Please select an insurance sub-category before uploading your document.",
    subCategoryLabel: "Insurance Type",
    uploadInstructions:
      "Upload your insurance certificate below. Verification will start automatically and pre-fill the document details. For multi-page documents, only the first page is analysed — please ensure the key insurance details (expiry date, coverage value, insured name) appear on page 1.",
  },
  pageCountWarning: {
    title: "Document may be truncated",
    body: "This file is larger than 5 MB. Only the first page will be used for verification. Please ensure your key insurance details (expiry date, coverage value, insured name) appear on page 1.",
    checkboxLabel: "I understand only the first page will be verified",
    confirmButton: "Confirm",
  },
  states: {
    pending_verification:
      "Your document has been submitted and is awaiting verification.",
    cap_reached: "Monthly upload limit reached",
    cap_reached_body:
      "You have reached your monthly insurance document upload limit. You can upload again after your limit resets.",
    submitting: "Uploading document…",
    confirm_page_truncate:
      "Only the first page of your document will be submitted for verification.",
  },
  upload: {
    success: "Document added successfully.",
    error: "Failed to upload document. Please try again.",
  },
  feedback: {
    prompt: "Was the auto-fill accurate?",
    thumbsUp: "Yes",
    thumbsDown: "No",
    addComment: "Add a comment (optional)",
    commentPlaceholder: "Tell us more about the accuracy…",
    submit: "Submit feedback",
    submitting: "Submitting…",
    successMessage: "Thanks — feedback recorded",
    alreadySubmitted: "Feedback already submitted.",
  },
  pending: {
    title: "Verification in progress",
    body: "Your document is being verified. This may take a few minutes. You can replace the file if it was uploaded incorrectly.",
    replaceFile: "Replace file",
    replaceFileLoading: "Uploading…",
  },
};
